import React, { useRef } from 'react';
import useClickOutside from '../../../common/hooks/useClickOutside';
import { IDocuSignData } from '../../../common/services/http/docuSignService';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { CLOSE_DOCUSIGN_DROPDOWN, SWITCH_MODAL, SWITCH_REDIRECTING_TO_DS_MODAL } from '../../../redux/types';
import useTranslate from '../../../common/hooks/useTranslate';

import './docuSignDropdown.scss';

interface INavigation {
  id: string;
  signData: any;
}

const DocuSignDropdown: React.FC<INavigation> = ({ id, signData }) => {
  const wrapperRef = useRef(null);
  const dispatch = useDispatch();
  const impersonate = useSelector((state: RootState) => state.impersonate.impersonate);

  const { t } = useTranslate();

  const goToDocuSign = (item: IDocuSignData): void => {
    if (impersonate) {
      dispatch({ type: SWITCH_MODAL });
    } else {
      dispatch({ type: SWITCH_REDIRECTING_TO_DS_MODAL, payload: item });
    }
  };

  const clickOutsideHandler = (): void => {
    dispatch({ type: CLOSE_DOCUSIGN_DROPDOWN });
  };

  useClickOutside(wrapperRef, clickOutsideHandler, id);

  return (
    <>
      {signData.length > 0 && (
        <div className="docusign-dropdown-wrapper" ref={wrapperRef}>
          {signData.map((item, key) => (
            <div className="docusign-dropdown-item" key={key}>
              <span>{item.name}</span>
              <span className="sign-btn pointer" onClick={() => goToDocuSign(item)}>
                {item.type !== 'signer' ? t('DOCUSIGN.VIEW_BUTTON') : item.isSigned === true ? t('DOCUSIGN.SIGNED_BUTTON') : t('DOCUSIGN.SIGN_BUTTON')}
              </span>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default DocuSignDropdown;
